export default class MessageMediaFilter {
    static $inject = ['$sce'];

    constructor($sce) {
        this.$sce = $sce;
    }

    static factory($sce) {
        'ngInject';
        const f = new MessageMediaFilter($sce);
        return f.filter.bind(f);
    }

    filter(message = {}) {
        const majorType = (message.mediaType || message.type || '').split('/')[0];

        if (message.value) {
            message.content = message.value;
        }

        if (this[majorType]) {
            return this[majorType](message);
        }

        return '';
    }

    application(message) {
        switch (message.mediaType || message.type) {
            case 'application':
            case 'application/vnd.lime.media-link+json':
                return this.$sce.trustAsHtml(this.mediaLink(message));
            case 'application/vnd.lime.location+json':
                return this.$sce.trustAsHtml(this.location(message));
            case 'application/vnd.omni.attendance+json':
                return this.attendance(message);
            default:
                return '';
        }
    }

    mediaLink(message) {
        const c = message.content;
        const majorType = c.type.split('/')[0];

        if (majorType === 'application' && c.uri) {
            return this.attachment(message);
        } else if (this[majorType]) {
            return this[majorType](message);
        } else if (c.uri) {
            return this.attachment(message);
        }

        return '';
    }

    attachment(message) {
        const c = message.content;
        return `
        <div class="message-content">
            <i class="icon icon-xs icon-material">&#xE24D;</i><a href="${c.uri}">${c.filename || c.uri}</a>
        </div>`;
    }

    image(message) {
        const c = message.content;
        return `
        <a href="${c.uri}" target="_blank" class="media-image">
            <img src="${c.previewUri || c.uri}" alt="${c.text || ''}" />
        </a>`;
    }

    audio(message) {
        const c = message.content;
        return `
        <audio controls="controls" preload="auto">
            <source src="${c.uri}" type="${c.type}" />
            <div class="message-content"><i class="icon icon-xs">&#xE24D;</i><a href="${c.uri}">${c.uri}</a></div>
        </audio>`;
    }

    video(message) {
        const c = message.content;
        return `
        <video controls>
            <source src="${c.uri}" type="${c.type}">
            <div class="message-content"><i class="icon icon-xs">&#xE24D;</i><a href="${c.uri}">${c.uri}</a></div>
        </video>`;
    }

    attendance(message) {
        return this.filter(message.content.content);
    }

    location(message) {
        const c = message.content;
        return `
        <a href="https://maps.google.com/?q=${c.latitude},${c.longitude}" target="_blank" class="media-image">
            <img src="https://maps.googleapis.com/maps/api/staticmap?key=AIzaSyCVc6560o7sy8DVhmL7lRMcMxzI0ToftFU&size=192x192&center=${c.latitude},${c.longitude}&zoom=15&markers=${c.latitude},${c.longitude}" alt="${c.text || ''}" />
        </a>`;
    }
}

// Explicit DI annotation for factory used by angular.filter registration
MessageMediaFilter.factory.$inject = ['$sce'];
